<template>
  <v-btn icon color="red" x-small @click="$emit('click')">
    <v-icon color="white" dark small>
      mdi-close
    </v-icon>
  </v-btn>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
button
  box-shadow 0px 0px 2px 1px #999999
  background-color red
</style>
